"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsNav = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _TabsModule = _interopRequireDefault(require("./Tabs.module.css"));
var _bind = _interopRequireDefault(require("classnames/bind"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cx = _bind.default.bind(_TabsModule.default);
/**
 * Use this component when you want the styling of Tabs,
 * but you need them to work with react-router-dom.
 */
var TabsNav = _ref => {
  var tabs = _ref.tabs,
    location = _ref.location;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _TabsModule.default.Container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TabsModule.default.List,
    role: "tablist",
    dir: "ltr"
  }, tabs.map(t => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    key: t.text + t.to,
    className: cx(_TabsModule.default.Tab, {
      Selected: location === t.to
    }),
    to: t.to,
    replace: t.replace
  }, t.text))));
};
exports.TabsNav = TabsNav;
//# sourceMappingURL=TabsNav.js.map